import { render } from "./Wrapper.vue?vue&type=template&id=4afc67c4&scoped=true"
const script = {}

import "./Wrapper.vue?vue&type=style&index=0&id=4afc67c4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afc67c4"]])

export default __exports__